import { API } from "./apiClient";

export const fetchPromotions = async () => {
  try {
    const response = await API.get("/promotions");
    return response.data?.data || [];
  } catch (error) {
    return [];
  }
};

export const fetchMyRewards = async () => {
    try {
      const response = await API.get(
        "/reward/myrewards"
      );
      return response.data?.data || [];
    } catch (error) {
      return [];
    }
  };
  
  export const addReward = async (payload) => {
    try {
      const response = await API.post("/reward/addreward", payload);
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: {
          message:
            error?.response?.data?.error?.message ||
            "Failed to save coupon",
        },
      };
    }
  };